import { Model } from '@/services/api/lib'

export default class Zone extends Model {
  resource () {
    return 'zones/v1/zones'
  }

  updateMethod () {
    return 'PATCH'
  }

  defaults () {
    return {
      code: '',
      label: '',
      territories: []
    }
  }

  validations () {
    return {
      'code': 'required|string',
      'label': 'required|string'
    }
  }
}
